<template>
  <div>
    <v-notification>
    </v-notification>
    <div class="activation-history__title">
      <img src="/img/svg/common/document-check.svg" alt=""/>
      <h1>{{ getLocalization('Top up history') }}</h1>
    </div>
    <div class="activation-history-partner">
      <base-table
          :columns="this.columns"
          table-class="vgt-table --pc new-design-table"
          :render-list-to-show="this.listToShow"
          :wrapperFiltersData="this.wrapperFiltersData"
          :use-green-pagination-simple="true"
          :dynamic-sort="true"
          :per-page-default="perPage"
          :table-title="null"
          :accept-filters-button-label="getLocalization('Apply filters')"
          :download-csv-text="getLocalization('Download CSV')"
          :enable-save-csv="true"
          csv-filename="topUpList"
          save-csv-url="/cabinet/client/topuphistory/downloadCsv"
          new-design-class="activation-history-partner__body"
      >
        <template v-slot:base-table-pagination-green-simple="props">
          <div class="activation-history-all__pagination">
            <green-custom-pagination
                :total="props.total"
                :perPage="perPage"
                :pageChanged="props.pageChanged"
                :perPageChanged="props.pageChanged"
            ></green-custom-pagination>
          </div>
        </template>
      </base-table>
      <div v-if="filteredList.length > 0" class="activation-history-partner__body">
        <div class="--mobile">
          <div v-for="row in filteredList" class="activation-history-all-card">
            <div class="--item --row --flex-1">
              <div class="--label">{{ getLocalization('Date') }}</div>
              <div class="--value">{{ row['created_at'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Top up sum') }}</div>
              <div class="--value">
                <div class="d-flex align-items-center gap-1">
                  <span>{{ row['change'] }}</span>
                </div>
              </div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Amount to currency') }}</div>
              <div class="--value">
                <div class="d-flex align-items-center gap-1">
                  <span>{{ row['currency_change'] }}</span>
                </div>
              </div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Status') }}</div>
              <div v-if="row['status_id'] === 2" class="--value">
                <div class="d-flex align-items-center gap-1">
                  <img src="/img/svg/common/round-check.svg" class="--icon" alt=""/>
                  <span>{{getLocalization('Successfully')}}</span>
                </div>
              </div>
              <div v-else class="--value">
                <div class="d-flex align-items-center gap-1">
                  <span>{{getLocalization(row['status'])}}</span>
                </div>
              </div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Top up type') }}</div>
              <div class="--value">{{ row['type'] }}</div>
            </div>
            <div class="--divider"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Vue from "vue";
import WrapperFiltersComponent from "../../../components/table/wrapperFilters.vue";
import BaseSendRequestMixin from "../../../components/mixins/BaseSendRequestMixin.vue";
import BaseMessagingMixin from "../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import GreenCustomPagination from "../../../components/table/pagination/greenCustomPagination.vue";

export default {
  name: "topUpHistory",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin
  ],
  components: {
    GreenCustomPagination,
    BaseTable,
    Multiselect,
    WrapperFiltersComponent
  },
  props: [
    'phoneActivations',
    'user',
    'translations'
  ],
  data: function () {
    return {
      filteredList: [],
      wrapperFiltersData: {
        title: this.getLocalization('Top up history'),
        filtersUrl: '/cabinet/client/topuphistory/getList',
        showResetFilterButton: true,
        showCollapseFilter: true,
        newDesign: true,
        items: {
          statuses: {
            enable: true,
            multiple: true,
            selectedKey: 'statuses',
            getDataLink: '/cabinet/client/topuphistory/getStatusesList',
            placeholder: this.getLocalization('Status'),
            specifyKeyForLabel: 'description',
            className: '--4-12',
            needLocalization: true
          },
          types: {
            enable: true,
            multiple: true,
            selectedKey: 'types',
            getDataLink: '/cabinet/client/topuphistory/getTypesList',
            placeholder: this.getLocalization('Payment type'),
            className: '--4-12',
            specifyKeyForLabel: 'description',
            needLocalization: true
          },
          date: {
            enable: true,
            dateFromText: this.getLocalization('Date from'),
            dateToText: this.getLocalization('Date to'),
            className: 'w-100',
            circle: true
          },
        }
      },
      timeoutIds: [],
      perPage: 50,
      columns: [
        {
          label: this.getLocalization('Date'),
          field: 'created_at',
          sortable: true,
          sortByColumn: 'date',
          width: '20%'
        },
        {
          label: this.getLocalization('Top up sum'),
          field: 'change',
          sortable: true,
          type: 'number',
          width: '15%'
        },
        {
          label: this.getLocalization('Amount to currency'),
          field: 'currency_change',
          sortable: true,
          type: 'number',
          width: '15%'
        },
        {
          label: this.getLocalization('Top up type'),
          field: 'type',
          sortable: false,
          width: '30%'
        },
        {
          label: this.getLocalization('Status'),
          field: 'status',
          sortable: false,
          width: '10%'
        },
      ],
    }
  },
  methods: {
    listToShow(list) {
      let data = [];
      for (let elem of list) {
        data.push({
          created_at: elem['created_at'],
          currency_change: elem['pay_amount'],
          change: elem['sum'],
          type: this.getLocalization(elem['type']['description']),
          status: this.getLocalization(elem['status']['description']),
          status_id: elem['status']['id'],
        });
      }
      this.setFilteredList(data);
      return data;
    },
    setFilteredList(response) {
      this.filteredList = [];
      this.filteredList = response;
    },
  },
}
</script>
<style>
.new-design-wrapper {
  width: 100%;
}
.activation-history-all__filter .--export {
  display: flex;
}
</style>
